import { Icon } from '../../../../../../components/UI'

const MyQuizTemplateCreatePreviewQuestion = ({ question, index }) => {
  const options = [question.option1, question.option2, question.option3, question.option4]

  const optionsContent = options.map((option, optionIndex) => {
    return (
      <div
        key={optionIndex}
        className="rounded-[8px] w-full bg-white shadow-button flex items-center px-[14px] py-[10px]"
      >
        <p className="flex-1 text-base font-normal text-primary-100">{question.question_text}</p>

        {question.correct_option === optionIndex + 1 && (
          <Icon name="check-circle-fill" color="#F79009" className="w-[24px] h-[24px]" />
        )}
      </div>
    )
  })

  return (
    <div className="w-full flex flex-col">
      <p className="text-sm font-medium text-primary-100 mb-[6px]">
        {index + 1}. {question.question_text}
      </p>

      <div className="w-full flex flex-col gap-y-[6px]">{optionsContent}</div>
    </div>
  )
}

export default MyQuizTemplateCreatePreviewQuestion
